// extracted by mini-css-extract-plugin
export default {"header":"wQWu_Vv5EwJmtv61O0kg","url":"wOjdVrg5WHTr6TAk_oNs","details":"DJ4QlzVWLhgVSTJiwz1v","pin":"gynzasTMV_y_A0p2z6Sf"};